import { createLink } from '@tanstack/react-router'

import { ComponentProps, forwardRef, type ForwardedRef } from 'react'
import { cn } from '../utils'

type Props = ComponentProps<'a'>

const ForwardRefComponent = forwardRef(({ className, ...props }: Props, ref: ForwardedRef<HTMLAnchorElement>) => {
  return <a {...props} className={cn('text-brand-700 decoration-brand-300/50 hover:underline', className)} ref={ref} />
})

ForwardRefComponent.displayName = 'StyledLink'

export const StyledLink = createLink(ForwardRefComponent)
